// src/components/ComingSoon.js
import React, { useState } from 'react';
import { FaInstagram, FaSoundcloud, FaYoutube, FaTiktok, FaMusic } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const SocialIcon = React.memo(({ IconComponent, url, isHovered, handleMouseMove, handleMouseLeave }) => (
  <Link
    to="/patience"
    onMouseEnter={handleMouseMove}
    onMouseLeave={handleMouseLeave}
    // Retirer l'attribut href puisque Link gère la navigation
    // href={url}
    // target="_blank"
    // rel="noopener noreferrer"
    onClick={(e) => {
      // Facultatif : Empêcher tout comportement par défaut si nécessaire
      // e.preventDefault();
    }}
  >
    <IconComponent
      className={`h-6 w-6 cursor-pointer transition duration-300 transform hover:scale-110 ${
        isHovered ? 'wave-effect' : 'text-black'
      }`}
    />
  </Link>
));

function ComingSoon() {
  const [isTextHovered, setIsTextHovered] = useState(false);
  const [hoveredIcon, setHoveredIcon] = useState(null);

  const handleTextMouseEnter = () => {
    setIsTextHovered(true);
  };

  const handleTextMouseLeave = () => {
    setIsTextHovered(false);
  };

  const handleIconMouseEnter = (iconName) => {
    setHoveredIcon(iconName);
  };

  const handleIconMouseLeave = () => {
    setHoveredIcon(null);
  };

  return (
    <div
      className="flex flex-col justify-between min-h-screen items-center bg-white text-black relative"
    >
      {/* Icônes sociales */}
      <div className="flex justify-end space-x-4 absolute top-4 right-4">
        <SocialIcon
          IconComponent={FaInstagram}
          url="https://www.instagram.com/allwox/"
          isHovered={hoveredIcon === 'instagram'}
          handleMouseMove={() => handleIconMouseEnter('instagram')}
          handleMouseLeave={handleIconMouseLeave}
        />
        <SocialIcon
          IconComponent={FaSoundcloud}
          url="https://soundcloud.com/allwoxmusic"
          isHovered={hoveredIcon === 'soundcloud'}
          handleMouseMove={() => handleIconMouseEnter('soundcloud')}
          handleMouseLeave={handleIconMouseLeave}
        />
        <SocialIcon
          IconComponent={FaYoutube}
          url="https://www.youtube.com"
          isHovered={hoveredIcon === 'youtube'}
          handleMouseMove={() => handleIconMouseEnter('youtube')}
          handleMouseLeave={handleIconMouseLeave}
        />
        <SocialIcon
          IconComponent={FaTiktok}
          url="https://www.tiktok.com"
          isHovered={hoveredIcon === 'tiktok'}
          handleMouseMove={() => handleIconMouseEnter('tiktok')}
          handleMouseLeave={handleIconMouseLeave}
        />
        <SocialIcon
          IconComponent={FaMusic}
          url="https://www.beatport.com/fr/search?q=allwox"
          isHovered={hoveredIcon === 'music'}
          handleMouseMove={() => handleIconMouseEnter('music')}
          handleMouseLeave={handleIconMouseLeave}
        />
      </div>

      {/* Texte principal */}
      <div className="flex-grow flex items-center justify-center">
        <h1
          className={`text-4xl md:text-6xl font-tiro font-bold text-center cursor-pointer ${
            isTextHovered ? 'wave-effect' : 'text-black'
          }`}
          onMouseEnter={handleTextMouseEnter}
          onMouseLeave={handleTextMouseLeave}
        >
          COMING SOON.
        </h1>
      </div>

      {/* Footer */}
      <footer className="text-sm text-gray-500 pb-4 mt-auto text-center">
        © 2024 Allwox
      </footer>
    </div>
  );
}

export default ComingSoon;
